import 'core-js/stable';

import React from 'react';
import { createRoot } from 'react-dom/client';
import {Provider} from 'react-redux';

import AuthorizedRequest from '../api/authorizedRequests';
import {store} from '../store/store.prod';
import App from './components/App';

AuthorizedRequest.setStore(store);

const container = document.getElementById('app');
const root = createRoot(container as Element);
root.render(
<Provider store={store}>
    <App/>
</Provider>);
